import { render, staticRenderFns } from "./SendMessageTemplateDetailModal.vue?vue&type=template&id=27bb61df&lang=pug"
import script from "./SendMessageTemplateDetailModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports